import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';

import { helpers } from '../../helpers';
import { UserState } from './user.interfaces';

@Injectable()
export class UserSelectors {
  public user$: Observable<UserState>;

  constructor(private store: Store<any>) {
    this.user$ = this.store
      .select(state => state.user);
  }

  getUser() {
    return this.user$
      .let((state$: Observable<UserState>) => state$
      .map(state => state.user)
      .filter(user => !helpers.isEmptyObject(user))
      .distinctUntilChanged());
  }
  
  getUserError() {
    return this.user$
      .let((state$: Observable<UserState>) => state$
      .map(state => state.error)
      .filter(error => error !== null)
      .distinctUntilChanged());
  }
  
  getUserLoading() {
    return this.user$
      .let((state$: Observable<UserState>) => state$
      .map(state => state.loading)
      .distinctUntilChanged());
  }
  
  getUserIsLoadingEnded() {
    return this.getUserLoading()
      .filter(loading => !loading);
  }
  
  getUserLoaded() {
    return this.user$
      .let((state$: Observable<UserState>) => state$
      .map(state => state.loaded)
      .distinctUntilChanged());
  }
  
  getUserIsLoaded() {
    return this.getUserLoaded()
      .filter(success => success);
  }
  
  getUserLanguage() {
    return this.user$
      .let((state$: Observable<UserState>) => state$
      .map(state => state.lang)
      .distinctUntilChanged());
  }
}


// WEBPACK FOOTER //
// ./src/app/logics/user/user.selectors.ts